import React, { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle, faSignInAlt } from '@fortawesome/free-solid-svg-icons';
import { SubmittedIllustration } from 'components/registration-shared/RegistrationIllustrations';
import {
  ADMIN_RESPONSE_HOURS,
  INVITE_LINK_TTL_HOURS
} from 'helpers/registrationMeta';

/**
 * Confirmation after a registration is submitted (D10). Kept short on purpose:
 * the request was received, we email when access is ready, and only the
 * agency can approve it. There is no account yet, so there's no automatic
 * redirect — just a button back to the sign-in page.
 *
 * The copy is fixed and never echoes the server's message, so a known and an
 * unknown email produce exactly the same screen (D11 / backend R2.5).
 */
const RegistrationSuccessPanel = () => {
  const headingRef = useRef(null);

  useEffect(() => {
    headingRef.current?.focus({ preventScroll: true });
  }, []);

  return (
    <div className="mym-success" role="status" aria-live="polite">
      <SubmittedIllustration width={210} />
      <h2
        ref={headingRef}
        tabIndex={-1}
        className="mym-reg-title"
        style={{ outline: 'none' }}
      >
        Your request has been received
      </h2>
      <p className="mym-reg-lead mx-auto" style={{ maxWidth: '30rem' }}>
        We'll email you when your access is ready. The link in that email
        expires after {INVITE_LINK_TTL_HOURS} hours.
      </p>

      <div
        className="mym-inline-note mym-tone-info text-start mx-auto mt-4"
        style={{ maxWidth: '30rem' }}
      >
        <FontAwesomeIcon icon={faInfoCircle} className="mt-1" />
        <div>
          MapYourMeds can't approve access for your agency. If you haven't heard
          back within {ADMIN_RESPONSE_HOURS} hours, contact your agency
          administrator.
        </div>
      </div>

      <div className="mt-4">
        <Link to="/" className="btn mym-btn-primary px-4">
          <FontAwesomeIcon icon={faSignInAlt} className="me-2" />
          Back to sign in
        </Link>
      </div>
    </div>
  );
};

export default RegistrationSuccessPanel;
